import { Component } from '@angular/core';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  standalone: false,
})
export class ReportsComponent {}
